// Centralized project data for Hudayriyat Golf Estates landing page
export const BRAND = {
  agency: "PK Properties",
  agencyLogo:
    "https://customer-assets.emergentagent.com/job_606c668e-ac75-4a3b-88be-ffaccdcdbf49/artifacts/n5v7c73i_-BLACK%20PRIMARY%20LOGO%20WITH%20EST-%20PK%20PROPERTIES.png",
  agent: "Carlton",
  phone: "+971 58 573 0039",
  phoneRaw: "971585730039",
  email: "carlton@pkproperties.ae",
};

export const PROJECT = {
  name: "Hudayriyat Golf Estates",
  developer: "Modon",
  zone: "Golf Living",
  island: "Hudayriyat Island",
  city: "Abu Dhabi",
  handover: "March 2030",
  paymentSplit: "40/60",
  story:
    "An exclusive Andalusian-inspired sanctuary set alongside Abu Dhabi's first championship 18-hole golf course, framed by serene water channels and rolling fairways on Hudayriyat Island.",
};

export const HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_investment-showcase-4/artifacts/rr0yicts_ChatGPT%20Image%20May%2022%2C%202026%2C%2003_16_03%20PM.png";

export const GALLERY = [
  {
    url: "https://customer-assets.emergentagent.com/job_investment-showcase-4/artifacts/zkslg8wn_6bedroomP.webp",
    caption: "Mansion living, indoor–outdoor flow",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_investment-showcase-4/artifacts/bb41c1uy_4bedroom-villa.webp",
    caption: "Open kitchen with marble island",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_investment-showcase-4/artifacts/vklp5y8k_5bed.webp",
    caption: "Range Villa, dining onto terrace",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_investment-showcase-4/artifacts/6dkypb6q_6bedroom.webp",
    caption: "Formal dining, garden-side",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_investment-showcase-4/artifacts/sfdc4klc_4bedroomTH.webp",
    caption: "Townhome interior in warm neutrals",
  },
];

export const ATTRACTIONS = [
  {
    name: "Marsana East Beach",
    body: "A new waterfront beach concept with white sand, day-clubs and beachfront dining.",
    url: "https://d1xqol1alpy9hf.cloudfront.net/sthudayriyatwebmobileprod/2025-01/Marsana-east-beach.jpg",
  },
  {
    name: "Surf Abu Dhabi",
    body: "The world's largest man-made wave pool, with coaching, retail and beachside lounges.",
    url: "https://d1xqol1alpy9hf.cloudfront.net/sthudayriyatwebmobileprod/2024-12/surf-banner.jpg",
  },
  {
    name: "321 Sports",
    body: "Olympic-scale fitness campus: gyms, courts, training labs, open-air fields.",
    url: "https://d1xqol1alpy9hf.cloudfront.net/sthudayriyatwebmobileprod/2025-02/321-sports-tile.jpg",
  },
  {
    name: "Circuit X",
    body: "Zip-lines, high-ropes & obstacle courses set across the island.",
    url: "https://d1xqol1alpy9hf.cloudfront.net/sthudayriyatwebmobileprod/2025-02/circuit-x-tile-news.jpg",
  },
  {
    name: "Bab Al Nojoum",
    body: "Beachside glamping, fire-pits and starlit dinners, minutes from your door.",
    url: "https://d1xqol1alpy9hf.cloudfront.net/sthudayriyatwebmobileprod/2025-02/ban-tile.jpg",
  },
  {
    name: "Marsana Night Beach",
    body: "Abu Dhabi's only night-bathing beach, with floodlit swimming until late.",
    url: "https://d1xqol1alpy9hf.cloudfront.net/sthudayriyatwebmobileprod/2025-07/night-beach-banner-light_banner-2.jpg",
  },
  {
    name: "Cycling & Trail X",
    body: "Scenic cycling loops and the city's first mountain-bike trail.",
    url: "https://d1xqol1alpy9hf.cloudfront.net/sthudayriyatwebmobileprod/2025-02/cycling-track-tile.jpg",
  },
  {
    name: "Splash Park",
    body: "Family water playground at Circuit X, with slides, splash zones and shaded cafés.",
    url: "https://d1xqol1alpy9hf.cloudfront.net/sthudayriyatwebmobileprod/2025-02/splash-park-tile.jpg",
  },
];

export const LANDMARKS = [
  { label: "Zayed International Airport", minutes: 33 },
  { label: "Abu Dhabi Global Market", minutes: 29 },
  { label: "Louvre Abu Dhabi", minutes: 31 },
  { label: "Yas Island & Theme Parks", minutes: 37 },
  { label: "Saadiyat Cultural District", minutes: 27 },
  { label: "Corniche Beach", minutes: 20 },
];

export const AMENITIES = [
  { name: "18-Hole Championship Golf Course" },
  { name: "Country Clubhouse" },
  { name: "Wellness & Spa Centre" },
  { name: "Fine Dining & Retail Promenade" },
  { name: "Multi-Sports Courts" },
  { name: "Private International School" },
  { name: "Cycling & Equestrian Trails" },
  { name: "Parks & Green Spaces" },
  { name: "Co-Working Pavilions" },
  { name: "Community Retail" },
];

// Full unit collection with investment data drawn from Modon factsheet & payment plan
export const UNITS = [
  {
    id: "th3",
    name: "3-Bedroom Townhome",
    sqm: 204,
    priceAED: 4250000,
    priceLabel: "From AED 4.25M",
    eoi: 75000,
    downpayment: 212500,
    handoverPayment: 2550000,
    estValueHandover: 6375000,
    capitalGain: 2125000,
    equityBeforeHandover: 1860523.95,
    roiOnEquity: 114,
    image:
      "https://customer-assets.emergentagent.com/job_investment-showcase-4/artifacts/sfdc4klc_4bedroomTH.webp",
    tagline: "The entry into Hudayriyat. Compact, layered, golf-adjacent.",
    feature: true,
  },
  {
    id: "th4",
    name: "4-Bedroom Townhome",
    sqm: 237,
    priceAED: 4950000,
    priceLabel: "From AED 4.95M",
    eoi: 75000,
    downpayment: 247500,
    handoverPayment: 2970000,
    estValueHandover: 7425000,
    capitalGain: 2475000,
    equityBeforeHandover: 2154523.95,
    roiOnEquity: 115,
    image:
      "https://customer-assets.emergentagent.com/job_investment-showcase-4/artifacts/sfdc4klc_4bedroomTH.webp",
    tagline: "Family-scaled. Roof terrace. Direct community access.",
  },
  {
    id: "gh4",
    name: "4-Bedroom Golf Home",
    sqm: 372,
    priceAED: 7350000,
    priceLabel: "From AED 7.35M",
    eoi: 100000,
    downpayment: 367500,
    handoverPayment: 4410000,
    estValueHandover: 11025000,
    capitalGain: 3675000,
    equityBeforeHandover: 3187523.95,
    roiOnEquity: 115,
    image:
      "https://customer-assets.emergentagent.com/job_investment-showcase-4/artifacts/bb41c1uy_4bedroom-villa.webp",
    tagline: "On-course living with private garden and pool.",
  },
  {
    id: "rv5",
    name: "5-Bedroom Range Villa",
    sqm: 547,
    priceAED: 10150000,
    priceLabel: "From AED 10.15M",
    eoi: 100000,
    downpayment: 507500,
    handoverPayment: 6090000,
    estValueHandover: 15225000,
    capitalGain: 5075000,
    equityBeforeHandover: 4363523.95,
    roiOnEquity: 116,
    image:
      "https://customer-assets.emergentagent.com/job_investment-showcase-4/artifacts/vklp5y8k_5bed.webp",
    tagline: "Statement architecture overlooking the driving range.",
  },
  {
    id: "fv6",
    name: "6-Bedroom Fairway Villa",
    sqm: 910,
    priceAED: 26550000,
    priceLabel: "From AED 26.55M",
    eoi: 100000,
    downpayment: 1327500,
    handoverPayment: 15930000,
    estValueHandover: 39825000,
    capitalGain: 13275000,
    equityBeforeHandover: 11251523.95,
    roiOnEquity: 118,
    image:
      "https://customer-assets.emergentagent.com/job_investment-showcase-4/artifacts/6dkypb6q_6bedroom.webp",
    tagline: "Front-row to the fairway. Indoor–outdoor living, refined.",
  },
  {
    id: "gm6",
    name: "6-Bedroom Golf Mansion",
    sqm: 1150,
    priceAED: 35550000,
    priceLabel: "From AED 35.55M",
    eoi: 250000,
    downpayment: 1777500,
    handoverPayment: 21330000,
    estValueHandover: 53325000,
    capitalGain: 17775000,
    equityBeforeHandover: 15181523.95,
    roiOnEquity: 117,
    image:
      "https://customer-assets.emergentagent.com/job_investment-showcase-4/artifacts/zkslg8wn_6bedroomP.webp",
    tagline: "The pinnacle. Private estate, generational asset.",
  },
];

export const FLOORPLANS = {
  th3: {
    unitId: "th3",
    label: "3-Bedroom Townhome",
    sqm: 204,
    bedrooms: "3",
    bathrooms: "3.5",
    parking: "2 cars",
    levels: "G + 1",
    groundFloor: "https://customer-assets.emergentagent.com/job_investment-showcase-4/artifacts/ilcrwhi6_3BR_TH_GF.png",
    firstFloor: "https://customer-assets.emergentagent.com/job_investment-showcase-4/artifacts/ukipx5v7_3BR_TH_1F.png",
    groundFloorRooms: [
      "Covered double parking",
      "Front landscaped garden",
      "Foyer & guest WC",
      "Open-plan living & dining",
      "Designer kitchen with island",
      "Utility / maid's quarter",
      "Private rear garden",
    ],
    firstFloorRooms: [
      "Principal bedroom suite",
      "Walk-in dressing area",
      "Ensuite bathroom with freestanding tub",
      "Two further bedrooms",
      "Family bathroom",
      "Landing / circulation hall",
    ],
  },
  th4: {
    unitId: "th4",
    label: "4-Bedroom Townhome",
    sqm: 237,
    bedrooms: "4 + maid",
    bathrooms: "4.5",
    parking: "3 cars",
    levels: "G + 1",
    groundFloor: "https://customer-assets.emergentagent.com/job_investment-showcase-4/artifacts/rvkhwnbr_4BR_TH_GF.png",
    firstFloor: "https://customer-assets.emergentagent.com/job_investment-showcase-4/artifacts/qpzd1k9q_4BR_TH_1F.png",
    groundFloorRooms: [
      "Three-car driveway",
      "Front & rear landscaped gardens",
      "Entrance foyer & guest powder room",
      "Open-plan living & dining (4-seat island)",
      "Designer kitchen + separate wet kitchen",
      "Guest bedroom with full ensuite",
      "Maid's quarters with private access",
      "Direct garden walkout",
    ],
    firstFloorRooms: [
      "Principal suite with private terrace",
      "Walk-in dressing room",
      "Ensuite with freestanding tub & twin vanity",
      "Two further bedrooms with shared bath",
      "Fourth bedroom ensuite",
      "Family landing / lounge",
      "Linen & storage",
    ],
  },
  rv5: {
    unitId: "rv5",
    label: "5-Bedroom Range Villa",
    sqm: 547,
    bedrooms: "5 + maid",
    bathrooms: "6.5",
    parking: "4 cars",
    levels: "G + 1",
    groundFloor: "https://customer-assets.emergentagent.com/job_investment-showcase-4/artifacts/c8olmp7q_%205%20bed%20range_GF.png",
    firstFloor: "https://customer-assets.emergentagent.com/job_investment-showcase-4/artifacts/kp6e82qi_5%20bed%20range_1F.png",
    groundFloorRooms: [
      "Four-car covered driveway",
      "Wrap-around landscaped gardens",
      "Grand double-height foyer",
      "Formal living lounge",
      "Family TV / media lounge",
      "Formal dining for ten",
      "Show kitchen with island",
      "Catering / wet kitchen + pantry",
      "Guest suite with full ensuite",
      "Powder room",
      "Maid's quarters with dedicated entry",
      "Driver's room",
    ],
    firstFloorRooms: [
      "Principal suite with private balcony",
      "His & hers walk-in dressing rooms",
      "Spa ensuite with freestanding tub & rain shower",
      "Four further bedroom suites",
      "Upstairs family lounge",
      "Study / library nook",
      "Linen & service rooms",
    ],
  },
  gh4: {
    unitId: "gh4",
    label: "4-Bedroom Golf Home",
    sqm: 372,
    bedrooms: "4 + maid",
    bathrooms: "5.5",
    parking: "3 cars",
    levels: "G + 1",
    groundFloor: "https://customer-assets.emergentagent.com/job_investment-showcase-4/artifacts/qp586q8k_4BR_villa_GF.png",
    firstFloor: "https://customer-assets.emergentagent.com/job_investment-showcase-4/artifacts/gg58tp6c_4BR_villa_1F.png",
    groundFloorRooms: [
      "Triple-car covered driveway",
      "Wrap-around landscaped garden",
      "Grand entrance foyer",
      "Formal living lounge",
      "Separate dining room (8-seat)",
      "Show kitchen with island",
      "Catering / wet kitchen",
      "Guest suite with ensuite",
      "Guest powder room",
      "Maid's quarters with separate access",
    ],
    firstFloorRooms: [
      "Principal suite with garden balcony",
      "Walk-in dressing room",
      "Spa ensuite with freestanding tub",
      "Three further bedroom suites",
      "Family lounge",
      "Shared family bathroom",
      "Linen / storage",
    ],
  },
  fv6: {
    unitId: "fv6",
    label: "6-Bedroom Fairway Villa",
    sqm: 910,
    bedrooms: "6 + staff",
    bathrooms: "8.5",
    parking: "4+ cars",
    levels: "G + 1 + Roof",
    groundFloor: "https://customer-assets.emergentagent.com/job_investment-showcase-4/artifacts/6k9349wz_fairways_GF.png",
    firstFloor: "https://customer-assets.emergentagent.com/job_investment-showcase-4/artifacts/8s2pl13m_fairways_1F.png",
    roofFloor: "https://customer-assets.emergentagent.com/job_investment-showcase-4/artifacts/p03t1f4f_fairways_RF.png",
    groundFloorRooms: [
      "Private swimming pool + sun deck",
      "Outdoor dining for twelve & shaded majlis",
      "Show kitchen with marble island",
      "Catering / wet kitchen + butler's pantry",
      "Triple living & dining hall (double-height)",
      "Formal majlis with private entrance",
      "Round dining room (8-seat)",
      "Guest powder room",
      "Maid's & driver's quarters",
      "4-car covered garage",
      "Landscaped courtyard garden",
    ],
    firstFloorRooms: [
      "Principal suite, fairway-facing",
      "His & hers walk-in dressing rooms",
      "Spa ensuite with freestanding tub + rain shower",
      "Four further bedroom suites",
      "Family lounge with landscaped terrace",
      "Study / library",
      "Service rooms & linen",
    ],
    roofFloorRooms: [
      "Sky lounge with bar",
      "Outdoor dining pavilion",
      "Games room with pool & foosball",
      "Roof garden with planting beds",
      "Guest WC",
      "Open-air terrace",
    ],
  },
  gm6: {
    unitId: "gm6",
    label: "6-Bedroom Golf Mansion",
    sqm: 1150,
    bedrooms: "6 + staff",
    bathrooms: "9.5",
    parking: "4-car garage",
    levels: "B + G + 1 + Roof",
    basementFloor: "https://customer-assets.emergentagent.com/job_investment-showcase-4/artifacts/d8hp1gg3_6%20bed%20golf%20mansion_BF.png",
    groundFloor: "https://customer-assets.emergentagent.com/job_investment-showcase-4/artifacts/lcezfogu_6%20bed%20golf%20mansion_GF.png",
    firstFloor: "https://customer-assets.emergentagent.com/job_investment-showcase-4/artifacts/39y9l0tc_6%20bed%20golf%20mansion_1F.png",
    roofFloor: "https://customer-assets.emergentagent.com/job_investment-showcase-4/artifacts/8xr6tkn3_6%20bed%20golf%20mansion_RF.png",
    basementFloorRooms: [
      "Private gym & wellness suite",
      "Home cinema / media lounge",
      "Wine cellar & tasting room",
      "Service kitchenette",
      "Plant & utility rooms",
      "Secondary staircase to ground",
      "Guest powder room",
    ],
    groundFloorRooms: [
      "Resort-scale swimming pool & sun terrace",
      "Outdoor dining for sixteen",
      "Double-height grand foyer",
      "Triple living & dining hall",
      "Show kitchen + catering kitchen + butler's pantry",
      "Round majlis with private entrance",
      "Formal majlis dining (round, 10-seat)",
      "Guest suite with ensuite",
      "Guest powder room",
      "4-car covered garage",
      "Maid's & driver's quarters",
      "Landscaped courtyard gardens",
    ],
    firstFloorRooms: [
      "Principal suite with private terrace",
      "His & hers walk-in dressing rooms",
      "Spa ensuite with freestanding tub + rain shower",
      "Five further bedroom suites, all ensuite",
      "Upstairs family lounge",
      "Study / library",
      "Roof-garden balconies",
      "Service & linen rooms",
    ],
    roofFloorRooms: [
      "Sky lounge with bar",
      "Outdoor dining pavilion (8-seat round)",
      "Games room with pool & foosball",
      "Roof garden with planting beds",
      "Guest WC",
      "Open-air terrace",
    ],
  },
};

// Back-compat alias for older imports
export const FLOORPLANS_3BR = FLOORPLANS.th3;

export const PAYMENT_SCHEDULE = [
  { stage: "EOI Booking Fee", date: "Reservation", percent: "Fixed" },
  { stage: "Down Payment", date: "On Booking", percent: "5%" },
  { stage: "ADM Fees", date: "After Booking", percent: "~2%" },
  { stage: "1st Installment", date: "Mar 2027", percent: "5%" },
  { stage: "2nd Installment", date: "Sep 2027", percent: "5%" },
  { stage: "3rd Installment", date: "Mar 2028", percent: "5%" },
  { stage: "4th Installment", date: "Sep 2028", percent: "5%" },
  { stage: "5th Installment", date: "Mar 2029", percent: "5%" },
  { stage: "6th Installment", date: "Sep 2029", percent: "5%" },
  { stage: "7th Installment", date: "Mar 2030", percent: "5%" },
  { stage: "Handover Payment", date: "Mar 2030", percent: "60%" },
];

export const BOOKING_STEPS = [
  {
    num: "01",
    title: "Complete EOI",
    body: "Submit your Expression of Interest with preferred typology, view orientation and contact details.",
  },
  {
    num: "02",
    title: "Verify Identity",
    body: "Provide a one-time-password verification along with passport / Emirates ID for the reservation file.",
  },
  {
    num: "03",
    title: "EOI Deposit",
    body: "Pay the booking fee via bank transfer or manager's cheque. Fully refundable if no unit is allocated.",
  },
  {
    num: "04",
    title: "Invitation to Book",
    body: "On allocation, you are invited to a private unit selection, signing of SPA and payment of the 5% down payment.",
  },
];

export const formatAED = (n) => {
  if (n >= 1000000) return `AED ${(n / 1000000).toFixed(2)}M`;
  if (n >= 1000) return `AED ${(n / 1000).toFixed(0)}K`;
  return `AED ${n.toLocaleString()}`;
};
